<script lang="ts">
  import { onMount } from 'svelte'
  // Props interface
  interface FeedItem {
    guid: string;
    link: string;
    mediaThumbnail: string;
    title: string;
  }

  // Component state
  let feedItems: FeedItem[] = [];
  let isLoading = true;
  let error: string | null = null;

  let controller: AbortController;

  onMount(async () => {
    try {
      controller = new AbortController();
      const res = await fetch('/api/proxy?type=blog', {
        signal: controller.signal,
        headers: {
          'Accept': 'application/json'
        }
      });
      if (!res.ok) throw new Error('Failed to fetch blog posts');
      const items = await res.json();
      feedItems = items.slice(0, 6);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Failed to fetch blog posts:', error);
        error = 'ブログ記事の読み込みに失敗しました';
      }
    } finally {
      isLoading = false;
    }

    return () => {
      if (controller) {
        controller.abort();
      }
    };
  });

  // Keyboard event handler for accessibility
  function handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      const target = event.target as HTMLElement;
      const link = target.closest('a');
      if (link) {
        link.click();
      }
    }
  }
</script>

<section class="sptr-media content-inner">
  <h3 class="topic-title">
    SPTR MEDIA
    <br class="br-sp" />
    <span>powered by</span>
    <a 
      href="https://blog.sptr.jp/"
      on:keydown={handleKeyDown}
    >
      <img src="img/sptr-media.png" alt="SPTR MEDIA" />
    </a>
  </h3>

  {#if isLoading}
    <p class="loading">読み込み中...</p>
  {:else if error}
    <p class="error">{error}</p>
  {:else if feedItems.length === 0}
    <p>現在記事はありません。</p>
  {:else}
    <ul class="sptr-media-list mt-20">
      {#each feedItems as item (item.guid)}
        <li>
          <a 
            href={item.link}
            on:keydown={handleKeyDown}
          >
            <img src={item.mediaThumbnail} alt="" />
            {item.title}
          </a>
        </li>
      {/each}
    </ul>
  {/if}

  <p class="item-center">
    <a 
      href="https://blog.sptr.jp/" 
      class="link__bullet-btn"
      on:keydown={handleKeyDown}
    >
      <span>もっと見る</span>
    </a>
  </p>
</section>

<style>
  /* Component-specific styles */
  :global(.sptr-media-list a) {
    transition: opacity 0.3s;
  }

  :global(.sptr-media-list a:hover) {
    opacity: 0.7;
  }

  :global(.link__bullet-btn) {
    transition: all 0.3s;
  }

  :global(.link__bullet-btn:hover) {
    background: #7521da;
    color: #fff;
  }

  .loading,
  .error {
    text-align: center;
    padding: 20px;
    font-size: 1.5rem;
    color: var(--color-main);
  }

  .error {
    color: #dc3545;
  }

  @media screen and (max-width: 768px) {
    .loading,
    .error {
      font-size: 1.3rem;
      padding: 15px;
    }
  }
</style>
